import React from 'react';
import { Link } from 'react-router-dom';
import { getAuth, clearAuth } from '../utils/auth';
import { FiMenu } from 'react-icons/fi';
import NotificationBell from './NotificationBell';

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const { userData } = getAuth();
  
  const handleLogout = () => {
    clearAuth();
    window.location.href = process.env.REACT_APP_FRONTEND_URL || 'https://3pl.datavisual.ca';
  };
  
  return (
    <header className="bg-white shadow-sm z-10">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            {/* Mobile menu button */}
            <button
              type="button"
              className="md:hidden h-10 w-10 inline-flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-3"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <span className="sr-only">Open sidebar</span>
              <FiMenu className="h-6 w-6" />
            </button>

            <div className="flex-shrink-0 flex items-center md:hidden">
              <Link to="/admin" className="text-lg font-bold text-gray-900">
                3PL System
              </Link>
            </div>
            <div className="hidden md:ml-6 md:flex">
              <div className="space-x-8 flex">
                <span className="text-gray-900 inline-flex items-center px-1 pt-1 text-sm font-medium">
                  Admin Dashboard
                </span>
              </div>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <NotificationBell />

            {/* User Info and Logout */}
            <div className="flex-shrink-0 relative">
              <div className="flex items-center">
                <div className="mr-3 hidden sm:block">
                  <p className="text-sm font-medium text-gray-700">{userData?.name || 'User'}</p>
                  <p className="text-xs text-gray-500 truncate">{userData?.email || 'No email'}</p>
                </div>
                <button
                  onClick={handleLogout}
                  className="inline-flex items-center justify-center rounded-md border border-red-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-red-700 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  <span className="hidden sm:inline">Logout</span>
                  <span className="sm:hidden">Exit</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 
